<template>
<component class="flexwrap" style="flex-direction: column" id="landingPageWhyBody" :is="isMobile?'carousel':'div'"
     :perPage="1" :minSwipeDistance="50" :paginationEnabled="true" :touchDrag="true" :autoplay="false" :loop="true"
     :autoplayTimeout="3500" paginationActiveColor="var(--goalBackgroundColor2)" paginationColor="#ffffff88" :paginationPadding="5" >
  <component id="landingPageReasons"  :is="isMobile?'slide':'div'">
    <div class="landingPageReasons">
      <i class="fa-duotone fa-earth-africa blocIcon"></i>
      <span class="smallTitle">Un apprentissage par immersion dans l’anglais du quotidien</span>
      <span class="description">Contrairement aux méthodes d’anglais classiques, tu apprends l’anglais tel qu’il est réellement parlé par la population.</span>

    </div>
    <div class="landingPageReasons">
      <i class="fa-duotone fa-panorama blocIcon"></i>
      <span class="smallTitle">Un contenu et un environnement agréable et familier</span>
      <span class="description">Tu choisis la série qui te convient grâce a nos recommandations.<br/> Si tu l'as déjà vue, c'est encore mieux !</span>


    </div>
    <div class="landingPageReasons">
      <i class="fa-duotone fa-books blocIcon" style="'--fa-secondary-color:var(--goalBackgroundColor);'"></i>
      <span class="smallTitle">Du vocabulaire pertinent sélectionné pour toi</span>
      <span class="description">Le vocabulaire est choisi en fonction de sa complexité, de ton niveau et de son utilité pour comprendre la série. </span>

    </div>
    <div class="landingPageReasons">
      <i class="fa-duotone fa-chart-line blocIcon"></i>
      <span class="smallTitle">Une progression mesurable grâce aux statistiques de ton profil</span>
      <span class="description">Le panneau de progression te permet de suivre le vocabulaire que tu as appris, ton avancement dans la série et ton assiduité. </span>

    </div>

  </component>
  <component id="landingPageUsages"  class="landingPageReasons"  :is="isMobile?'slide':'div'">
    <i class="fa-duotone fa-chart-network blocIcon"></i>
    <span class="smallTitle">Des séries et lexiques pour tous les usages</span>
    <div class="description">
      <div id="usages">
        <h3>Au travail</h3>
        <div class="smallRoundImage">
          <img src="@/assets/landing_page/TheOffice.jpg" alt="Apprends l'anglais avec The Office"/>
        </div>

        <h3>En Erasmus</h3>
        <div class="smallRoundImage">
          <img src="@/assets/landing_page/Community.jpg" alt="Apprends l'anglais avec Community"/>
        </div>

        <h3>En médecine</h3>
        <div class="smallRoundImage">
          <img src="@/assets/landing_page/NewAmsterdam.jpg" alt="Apprends l'anglais avec New Amsterdam"/>
        </div>

        <h3>En droit</h3>
        <div class="smallRoundImage">
          <img src="@/assets/landing_page/Suits.png" alt="Apprends l'anglais avec Suits"/>
        </div>

        <h3>En politique</h3>
        <div class="smallRoundImage">
          <img src="@/assets/landing_page/HouseOfCards.jpg" alt="Apprends l'anglais avec House of Cards"/>
        </div>

        <h3></h3>
        <div><i class="fa-solid fa-ellipsis" style="font-size: 3em"></i></div>

      </div>
    </div>

  </component>



</component>
</template>

<script>
import {Carousel, Slide} from "vue-carousel";
import {mapGetters} from "vuex";

export default {
  name: "landingPageWhy",

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  components: {
    Carousel,
    Slide,
  }
}
</script>

<style scoped>
  #landingPageWhyBody{
    width: 100%;
  }
  #landingPageReasons{
    display: grid;
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2vw;

  }
  .blocIcon{
    font-size: 2.5vw;
    justify-self: center;
  }
  .landingPageReasons{
    display: grid;
    grid-template-columns: 4.5vw 1fr;
    grid-template-rows: auto 1fr;
    grid-gap: 0.3vw;
    justify-items: left;
    align-items: center;
  }
  #usages{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: auto 1fr;
    grid-auto-flow: column;
    grid-gap: 0.5vw;
    justify-items: center;
    align-items: center;
  }
  #usages>h3{
    font-weight: bold;
  }
  .smallRoundImage{
    height: 5vw;
    width: 5vw;
    border-radius: 5vw;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;

  }
  .smallRoundImage>img{
    height: 5vw;
    width: 5vw;
    object-fit: cover;
  }
  .smallTitle{
    font-weight: bold;
  }
  .description{
    grid-column: 2/3;
    grid-row: 2/3;
    text-align: left;
    width: 100%;
    align-self: flex-start;

  }

  @media screen and (max-device-width: 767px) {
    #landingPageWhyBody{
      height: fit-content;
      width: 100vw;
      display: block;
      justify-self: center;
      font-size: auto;
      transform: translateX(-8vw);
      overflow: visible;
    }
    #landingPageReasons{
      grid-template-rows: auto auto auto auto auto;
      grid-template-columns: 1fr;
      grid-gap: 6vw;
      transform: translateX(-3vw);
      width: 84vw;
      max-width: 84vw;
      margin: 0 8vw 0 8vw;
    }
    #landingPageUsages{
      width: 86vw;
      max-width: 86vw;
      margin: 0 6vw 0 6vw;
    }
    .blocIcon{
      font-size: 8vw;
      justify-self: center;
    }
    .landingPageReasons{
      display: grid;
      grid-template-columns: 15vw 1fr;
      grid-template-rows: auto 1fr;
      grid-gap: 0.3vw;
      justify-items: left;
      align-items: center;
    }
    #usages{
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto 1fr auto 1fr auto 1fr;
      grid-auto-flow: column;
      grid-column-gap: 4vw;
      grid-row-gap: 4vw;
      justify-items: center;
      align-items: center;
      transform: translateX(-6vw);
    }
    #usages>h3{
      font-weight: bold;
      margin-top: 3vw;
    }
    .smallRoundImage{
      height: 28vw;
      width: 28vw;
      border-radius: 30vw;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .smallRoundImage>img{
      height: 28vw;
      width: 28vw;
    }
    .smallTitle{
      font-weight: bold;
      font-size: 1.1em;
    }
    .description{
      grid-column: 2/3;
      grid-row: 2/3;
      text-align: left;
      width: 100%;
      align-self: flex-start;
    }

  }
</style>